import ApplicationReports from "./ApplicationReports";

const UnderReviewApplications = () => {
  return(
    <ApplicationReports status="7" title="Under Review Applications Report" heading="Under Review Applications"></ApplicationReports>
  )
};

export default UnderReviewApplications;
